import axios from 'axios'
import { API_BASE_URL } from '@/config'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
})

// 统一解析 { code, data } 格式，list 接口直接返回 data 数组
api.interceptors.response.use(res => {
  const body = res.data
  if (body && body.code === 0 && body.data !== undefined) {
    res.data = body.data
  }
  return res
})

export default {
  list() {
    return api.get('/invoices')
  },
  get(id) {
    return api.get(`/invoices/${id}`)
  },
  save(data) {
    return api.post('/invoices', data)
  },
  update(id, data) {
    return api.request({ method: 'put', url: `/invoices/${id}`, data })
  },
  delete(id) {
    return api.delete(`/invoices/${id}`)
  },
  exportPdf(id) {
    return api.get(`/invoices/${id}/pdf`, { responseType: 'blob' })
  }
}
